import React from 'react';

import { Font } from '@react-pdf/renderer';

import { parseDataToApi } from 'utils/parseDataToApi';

import { downloadRentalContract, generateSubscriptionPreview } from 'services/api';
import { mountCreateContractPayload } from 'utils/mountCreateContractPayload';
import { computePdfSha256 } from 'utils/pdfAcceptance';

export default async function ContractPDF({ basicInfo = {}, solutionInfo = {}, financeInfo = {} }) {
  const robotoBoldFontUrl = 'https://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf';

  Font.register({
    family: 'Roboto Bold',
    src: robotoBoldFontUrl,
  });

  const vehicle_camera = solutionInfo?.cameraTypes?.conteleCamCount || 0;
  const vehicle_camera_ia = solutionInfo?.cameraTypes?.conteleCamIaCount || 0;
  const camera_setup = (vehicle_camera + vehicle_camera_ia) || 0;

  const isAllTrackers = solutionInfo?.trackersBatch?.isAllTrackers ?? true;

  const subscriptionData = parseDataToApi({
    ...basicInfo,
    contele_system: solutionInfo?.vehicleManager?.conteleSystemCount || 0,
    contele_tracker: solutionInfo?.vehicleManager?.conteleTrackerCount || 0,
    plug_and_play: solutionInfo?.quantityTypes?.trackerPlugAndPlayCount || 0,
    tracker_2g: solutionInfo?.quantityTypes?.tracker2GCount || 0,
    tracker_4g: (solutionInfo?.quantityTypes?.tracker4GCount || 0) + (solutionInfo?.quantityTypes?.trackerPlugAndPlayCount || 0),
    blocking_12_volts: solutionInfo?.blocker?.useBlocker ? parseInt(solutionInfo?.blocker?.twelveVoltsCount) : 0,
    blocking_24_volts: solutionInfo?.blocker?.useBlocker ? parseInt(solutionInfo?.blocker?.twentyFourVoltsCount) : 0,
    fine_auto_update: solutionInfo?.finesManager?.fineManager || false,
    vehicle_camera,
    vehicle_camera_ia,
    discountCoupon: financeInfo?.confirmation?.coupon || '',
    paymentMethod: financeInfo?.payment?.paymentType,
    creditCardInfo: financeInfo?.payment?.creditCard,
    camera_setup,
    expirationDate: financeInfo?.expirationDate?.expirationDate,
    consultantId: basicInfo.gettingStarted?.seller_id,
    partial_shipment: !isAllTrackers,
    first_batch_quantity: isAllTrackers ? 0 : (solutionInfo?.trackersBatch?.trackersQuantity || 0),
  });

  const responseSubscriptionPreview = await generateSubscriptionPreview({ subscriptionData });

  const create_contract_payload = mountCreateContractPayload(responseSubscriptionPreview);

  const response_blob = await downloadRentalContract({ create_contract_payload });

  const pdf_url = window.URL.createObjectURL(response_blob);

  const pdfSha256 = await computePdfSha256(response_blob);

  const hasValidSubscriptionPreview = responseSubscriptionPreview?.billing_preview;

  if (!hasValidSubscriptionPreview) {
    throw new Error('Fail to generate preview response');
  }

  const subscriptionItems = responseSubscriptionPreview.billing_preview.subscription_items;

  const hasItemsInSubscription = Array.isArray(subscriptionItems) && subscriptionItems;

  if (!hasItemsInSubscription) {
    throw new Error('No items founded');
  }

  const view = (
    <iframe
      title={Math.random()}
      style={{ width: '100%', height: '100%' }}
      src={pdf_url}
    />
  );

  return { view, pdfBlob: response_blob, pdfSha256 };
}
